/**
 * 消息处理器注册与分发
 */
import type { StreamMessageHandler, StreamMessageData, HandlerContext } from '../types';
import { aiThinkingHandler } from './ai-thinking-handler';
import { toolDisplayHandler } from './tool-display-handler';
import { flagHandler } from './flag-handler';
import { inlineTableHandler } from './inline-table-handler';
import { pendingUserInputHandler } from './pending-user-input-handler';

/** 默认处理器列表（flagHandler 优先处理 start_flag/stop_flag 消息） */
const defaultHandlers: StreamMessageHandler[] = [
  flagHandler,
  inlineTableHandler,
  pendingUserInputHandler,
  aiThinkingHandler,
  toolDisplayHandler,
];

/**
 * 创建消息处理器管理器
 */
export function createHandlerManager(customHandlers?: StreamMessageHandler[]) {
  const handlers = customHandlers ?? defaultHandlers;

  /**
   * 处理流式消息
   * @returns 是否已处理并应结束流
   */
  const handleMessage = (data: StreamMessageData, ctx: HandlerContext): boolean => {
    for (const handler of handlers) {
      if (handler.canHandle(data)) {
        return handler.handle(data, ctx);
      }
    }
    return false;
  };

  /**
   * 注册新处理器
   */
  const registerHandler = (handler: StreamMessageHandler) => {
    handlers.push(handler);
  };

  return {
    handleMessage,
    registerHandler,
    handlers,
  };
}

export {
  aiThinkingHandler,
  toolDisplayHandler,
  flagHandler,
  inlineTableHandler,
  pendingUserInputHandler,
};
export type { StreamMessageHandler };
